import posthog from 'posthog-js'

const projectToken = import.meta.env.PUBLIC_POSTHOG_TOKEN?.trim()
const apiHost = import.meta.env.PUBLIC_POSTHOG_HOST?.trim()

export function initAnalytics(): void {
  if (!projectToken && !apiHost) return

  if (!projectToken || !apiHost) {
    throw new Error('PostHog requires both PUBLIC_POSTHOG_TOKEN and PUBLIC_POSTHOG_HOST')
  }

  // Validate the configured endpoint before handing it to the SDK. This also
  // permits self-hosted PostHog instances and reverse-proxy paths.
  const { href: validatedApiHost } = new URL(apiHost)

  posthog.init(projectToken, {
    api_host: validatedApiHost,
    defaults: '2026-05-30',
    autocapture: true,
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: 'identified_only',
  })

  posthog.register({ surface: 'playground' })
  posthog.capture('$pageview')
}
